import Id from './Id';
import Created from './Created';
import Updated from './Updated';
import Name from './Name';
import From from './From';
import To from './To';
import IsValid from './IsValid';


export const labels = {
  Id: 'Azonosító',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
  Name: 'Név',
  From: 'Érvényesség kezdete',
  To: 'Érvényesség vége',
  IsValid: 'Érvényes',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Name',
}, {
  value: 'From',
}, {
  value: 'To',
}, {
  value: 'IsValid',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
}, {
  value: 'IsValid',
}, {
  value: 'From',
}, {
  value: 'To',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Created,
  Updated,
  Name,
  From,
  To,
  IsValid,
};
